// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AppProvider } from "./context/AppVarsContext";
import Homepage from './views/hompepage';
import GtmInstall from "./views/gtm-main";
import themeFile from './theme.json';
import { createTheme, ThemeProvider } from "@mui/material";
import NotFound from "./views/not-found";

const App = () => {
  const getLastItem = (thePath) => thePath.substring(thePath.lastIndexOf("/") + 1);
  const clientID = getLastItem(window.location.pathname);


  const theme = createTheme(themeFile);


  return (
    <Router>
      <ThemeProvider theme={theme}>
        <AppProvider appid={"a27afab5-1ea7-4a8c-9044-cd0a2d8d98b2"}>
          <Routes>
            <Route path="/status/:id" element={<Homepage clientID={clientID} />} />
            <Route path="/gtm-install/:id" element={<GtmInstall clientID={clientID} />} />
            {/* 404 Not Found Route */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AppProvider>
      </ThemeProvider>
    </Router>

  );
};

export default App;
